<template>
    <table-template :queryParams="queryParams" actionUrl="/withdrawAccount/findAdminWithdrawFlowDetails.action" ref="width-draw-records">
        <template slot="search">

            提现账户余额：{{canUseMoney/100}}元&nbsp;&nbsp;<el-button type="warning" @click="exportExcel()">导出</el-button>

        </template>
        <template slot="item">
            <el-table-column
                    label="创建时间">
                <template scope="scope">
                    {{scope.row.createTime|dateTimeFormat}}
                </template>
            </el-table-column>
            <el-table-column
                    label="金额">
                    <template scope="scope">
                        {{scope.row.money/100}}
                    </template>
            </el-table-column>
            <el-table-column
                    label="关联单号"
                    prop="orderNumber">
            </el-table-column>
            <el-table-column
                    label="类型"
                    prop="type"
            >

            </el-table-column>

        </template>
    </table-template>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
import Config from '@/framework/configs/Config'
import distributor from '@/framework/models/distributor'

export default {
  name: 'width-draw-record',
  data () {
    return {
      createTimeSearch: null,
      payTimeSearch: null,
      canUseMoney: null,
      queryParams: { channelId: null }

    }
  },
  created () {
    let id = null
    let userInfo = localStorage.userInfo
    if (userInfo.id) {
      id = userInfo.id
    } else if (userInfo.employeeId) {
      id = userInfo.employeeId
    }
    this.queryParams.channelId = id
    this.loadDistributorData()
  },
  components: { TableTemplate },
  filters: {
  },
  methods: {

    loadDistributorData () {
      let _this = this
      let id = null
      let userInfo = JSON.parse(localStorage.userInfo)
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      let params = {
        channelId: id
      }

      let listener = {
        success (dataInfo) {
          let datas = dataInfo.datas
          _this.canUseMoney = datas.canUsedMoney
        }
      }

      distributor.selectWeChatMchInfo(_this, params, listener)
    },
    exportExcel: function () {
      let userInfo = JSON.parse(localStorage.userInfo)
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      let url = Config.baseUrl + '/distributor/exportDistributorWidthRecordList.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + '&channelId=' + id
      window.location.href = url
    }
  }
}
</script>
